import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const companyApi = createApi({
  reducerPath: 'companyApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Company', 'Storage'],
  endpoints: (builder) => ({
    // Get current user's company
    getMyCompany: builder.query({
      query: () => '/companies/me',
      providesTags: ['Company'],
    }),

    // Get company storage information
    getMyCompanyStorage: builder.query({
      query: () => '/companies/me/storage',
      providesTags: ['Storage'],
    }),

    // Get company by ID
    getCompany: builder.query({
      query: (id) => `/companies/${id}`,
      providesTags: (result, error, id) => [{ type: 'Company', id }],
    }),

    // Update company
    updateCompany: builder.mutation({
      query: ({ id, ...company }) => ({
        url: `/companies/${id}`,
        method: 'PUT',
        body: company,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Company', id },
        'Company',
      ],
    }),
  }),
});

export const {
  useGetMyCompanyQuery,
  useGetMyCompanyStorageQuery,
  useGetCompanyQuery,
  useUpdateCompanyMutation,
} = companyApi;
